const EARTH_RADIUS_METERS = 6371000;

const toRad = (deg) => (deg * Math.PI) / 180;

// Great-circle distance in meters. Advisory only — the server re-verifies.
export function haversineMeters(lat1, lon1, lat2, lon2) {
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return EARTH_RADIUS_METERS * c;
}

// Returns { geofence, distance } for the nearest geofence the point is inside,
// or null if outside all of them.
export function matchGeofence(lat, lon, geofences = []) {
  let best = null;
  for (const g of geofences) {
    const distance = haversineMeters(lat, lon, g.latitude, g.longitude);
    if (distance <= g.radius_meters && (!best || distance < best.distance)) {
      best = { geofence: g, distance };
    }
  }
  return best;
}

export function nearestGeofence(lat, lon, geofences = []) {
  let best = null;
  for (const g of geofences) {
    const distance = haversineMeters(lat, lon, g.latitude, g.longitude);
    if (!best || distance < best.distance) best = { geofence: g, distance };
  }
  return best;
}
